import { useAuth } from "@/hooks/use-auth";

export function AuthBootstrap() {
  useAuth();
  return null;
}
